import { MATERIAL_VIEWS } from '../../../constants/search';
import qualityEventsHelpers, { stringifyExtra } from '../quality-events.helpers';

export const FAVORITES_PAGE_QUALITY_EVENTS = {
    createFavoritesList() {
        qualityEventsHelpers.track({ type: 'createFavoritesList', extra: getExtra() });
    },
    clickFavoritesList(favoritesCount: number) {
        qualityEventsHelpers.track({
            type: 'clickFavoritesList',
            extra: getExtra({ favorites_count: favoritesCount })
        });
    },
    clickMaterialFromFavorites({ item, itemIndex }: { item: Material; itemIndex: number }) {
        qualityEventsHelpers.track({
            type: 'clickMaterialFromFavorites',
            extra: getExtra(),
            ...qualityEventsHelpers.extractMaterialsData(item, { itemIndex })
        });
    },
    viewFavorites({ from }: { from: 'header_icon' | 'profil_menu' }) {
        qualityEventsHelpers.track({ type: 'viewFavorites', extra: getExtra({ from }) });
    },
    addToFavorites(
        material: Material,
        materialIndex?: number,
        from?: 'fromMaterialPage' | 'fromFavorites',
        searchRequestId?: string
    ) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(material, { itemIndex: materialIndex }),
            extra: stringifyExtra({ from, search_request_id: searchRequestId }),
            type: 'addToFavorites'
        });
    },
    removeFromFavorites(
        material: Material,
        materialIndex?: number,
        from?: 'fromMaterialPage' | 'fromFavorites',
        searchRequestId?: string
    ) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(material, { itemIndex: materialIndex }),
            extra: stringifyExtra({ from, search_request_id: searchRequestId }),
            type: 'removeFromFavorites'
        });
    },
    changeView(newView: MATERIAL_VIEWS): void {
        qualityEventsHelpers.track({
            extra: newView,
            type: 'changeViewInFavorites'
        });
    }
};

const getExtra = (extraFields: Record<string, string | number> = {}): string | null =>
    JSON.stringify({ ...getDateAndTime(), ...extraFields });
const getDateAndTime = (): Record<string, string | number> => {
    const now = new Date();

    return {
        date: now.toISOString(),
        time: now.getTime()
    };
};
